import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { authApi } from '../api';
import { Form, Button } from 'react-bootstrap';

const ConfirmEmail = () => {
    const { confirmationToken } = useParams();
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [inputToken, setInputToken] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (confirmationToken) {
            const confirmEmail = async () => {
                setLoading(true);
                try {
                    await authApi.confirmEmail(confirmationToken);
                    setMessage('Ваш email успешно подтвержден!');
                    setTimeout(() => navigate('/login'), 2000);
                } catch (error) {
                    setMessage(`Ошибка: ${error.message}`);
                } finally {
                    setLoading(false);
                }
            };
            confirmEmail();
        }
    }, [confirmationToken, navigate]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            await authApi.confirmEmail(inputToken);
            setMessage('Ваш email успешно подтвержден!');
            setTimeout(() => navigate('/login'), 2000);
        } catch (error) {
            setMessage(`Ошибка: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="confirm-email-container">
            <h2>Подтверждение email</h2>
            {confirmationToken ? (
                <div>
                    {loading ? (
                        <p>Идёт подтверждение...</p>
                    ) : (
                        <p>{message}</p>
                    )}
                </div>
            ) : (
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="formToken">
                        <Form.Label>Введите токен подтверждения:</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Токен подтверждения"
                            value={inputToken}
                            onChange={(e) => setInputToken(e)}
                            required
                        />
                    </Form.Group>
                    <Button variant="primary" type="submit" disabled={loading}>
                        Подтвердить email
                    </Button>
                    {message && <p style={{ color: 'red' }}>{message}</p>}
                </Form>
            )}
        </div>
    );
};

export default ConfirmEmail;